import { Box } from '@mui/material';
import './App.css';
import FileProcessing from './components/file-processing';

function App() {
  return (
    <Box>
      <FileProcessing />
    </Box>
  );
}

export default App;
